import React from 'react';
import { Modal, Result, Button, ModalFuncProps, ModalProps, ResultProps } from 'antd';
import { dataTestIdFromTitle } from 'vl-common/src/utils';

type ErrorModalProps = Omit<ModalProps, 'onOk' | 'footer'> & {
  'data-testid'?: string;
  subTitle?: React.ReactNode;
  resultProps?: Omit<ResultProps, 'extra' | 'status' | 'subtitle'>;
};

export const ErrorModal = ({
  title,
  subTitle = null,
  onCancel,
  cancelText = 'OK',
  'data-testid': dataTestid = '',
  resultProps,
  ...rest
}: ErrorModalProps) => (
  <Modal centered footer={null} closable={false} onCancel={onCancel} {...rest}>
    <Result
      status="error"
      subTitle={subTitle}
      extra={[
        <Button key="submit" onClick={onCancel} data-testid={dataTestid}>
          {cancelText}
        </Button>
      ]}
      {...resultProps}
      title={title && <div data-testid={dataTestIdFromTitle(title)}>{title}</div>}
    />
  </Modal>
);

export const errorModal = ({ ...otherProps }: ModalFuncProps) =>
  Modal.error({
    centered: true,
    ...otherProps,
    ...(otherProps.title && {
      title: <div data-testid={dataTestIdFromTitle(otherProps.title)}>{otherProps.title}</div>
    })
  });
